import { GET_THIRD_PARTY_BENEFICIARIES } from "../types/thirdPartyBeneficiaryType";

const initialState = {
    thirdPartyBeneficiaries: []
};

const thirdPartyBeneficiaryReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_THIRD_PARTY_BENEFICIARIES:
            return {
                ...state,
                thirdPartyBeneficiaries: payload
            };
        default:
            return state;
    }
};

export default thirdPartyBeneficiaryReducer;
